module.exports = require('./helpers/bundle-url').getBundleURL('jWbtw') + "PAXGLogo.814ce36e.svg";